const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<a href="https://github.com/cloudfour/cloudfour.com-patterns">
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `brands/github`], [`inline`, true]]), false, false, 2));
                this.echo(`  <span class="u-hidden-visually">
    View this project on GitHub
  </span>
</a>
`);
            }

            getTemplateName() {
                return `a5b308fd330edaab8864578f6003901535730d05669f9d905c921aefc39096ea`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a5b308fd330edaab8864578f6003901535730d05669f9d905c921aefc39096ea`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'a5b308fd330edaab8864578f6003901535730d05669f9d905c921aefc39096ea');

let template = env.loadTemplate('a5b308fd330edaab8864578f6003901535730d05669f9d905c921aefc39096ea');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/display/demo/hidden-visually.twig", args: context }
     );
     return rendered;;
};